import client from "../client/client";

class CustomizableProjectPagesService {
	getAllCustomPagesToCreate({ portfolioId }, cancelToken) {
		return client.get(`/portfolio/${portfolioId}/custom-page`, { config: { cancelToken } });
	}

	getAllCustomPages({ projectId }, cancelToken) {
		return client.get(`/projects/${projectId}/custom-pages`, { config: { cancelToken } });
	}

	getCustomPage({ projectId, customPageId }, cancelToken) {
		return client.get(`/projects/${projectId}/custom-pages/${customPageId}`, { config: { cancelToken } });
	}

	updateCustomPage({ projectId, customPageId }, { uuid, value }, cancelToken) {
		return client.patch(`/projects/${projectId}/custom-pages/${customPageId}`, {
			payload: {
				uuid,
				value,
			},
			config: { cancelToken },
		});
	}

	createCustomPage({ customPageId }, payload, cancelToken) {
		return client.post(`/custom-pages/${customPageId}`, { payload, config: { cancelToken } });
	}

	getNameCustomizablePage({ portfolioId }, cancelToken) {
		return client.get(`/portfolio/${portfolioId}/custom-page`, { config: { cancelToken } });
	}

	updateTreeCustomPage(
		{ projectId, customPageId },
		{ fieldUuid, toBeAdded = null, toBeDeleted = null },
		cancelToken
	) {
		return client.patch(`/projects/${projectId}/custom-pages/${customPageId}/multi`, {
			payload: {
				fieldUuid,
				toBeAdded,
				toBeDeleted,
			},
			config: { cancelToken },
		});
	}

	setProjectArchiveStatus({ projectId }, status, cancelToken) {
		return client.patch(`/custom-page/projects/${projectId}`, {
			payload: status,
			config: { cancelToken },
		});
	}

	getCustomPageProjectDetails({ projectId }, cancelToken) {
		return client.get(`/me/custom-page/projects/${projectId}`, {
			config: { cancelToken },
		});
	}
}
export default new CustomizableProjectPagesService();
